import { Component } from "solid-js";
import { createSocialShare, PINTEREST } from "@solid-primitives/share";
import { cleanImagePath } from "../../api";
import "./index.css";
import { Artwork } from "../../types";

type Props = {
    artwork: Artwork;
}

export const PinterestShareButton : Component<Props> = ({ artwork }) => {
    const shareClicked = (e: Event) => {
        e.preventDefault();
        const artistName = artwork.artist.firstName + " "  + artwork.artist.lastName;
        const artworkUrl = window.location.href;
        const description = `${artwork.title} by ${artistName}`;
        const media = `https://www.artrenewal.org${cleanImagePath(artwork.primaryImage.url)}?mode=crop&maxWidth=1000&maxHeight=1000`;
        const [share, close] = createSocialShare(() => ({
            title: description,
            url: artworkUrl,
            description,
            media
        }));
        share(PINTEREST);
    }
    return (
        <>
            <span style="position: relative; top: -3px;" onClick={shareClicked}>
                <img src={"/Images/icons/pinterest.svg"} style="height: 1em; width: auto;" />
            </span>
        </>
    );
}